import { MEMBER_URL, SUBASTAS_URL } from '../constants/Constants';

export const goToLogin = () => {
  window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}'`;
};
